import { log } from '@dustin-web/microsite-config/src/logger'

const decode = (phrase: string, decoder: (value: string) => string) => {
  try {
    return decoder(phrase)
  } catch (err) {
    if (!(err instanceof URIError)) {
      throw err
    }

    log.warn({ err }, 'Invalid encoding in search phrase')
    return phrase
  }
}

export const decodeSearchPhrase = (phrase: string) => decode(phrase, decodeURIComponent)

export const decodeSearchPath = (phrase: string) => decode(phrase, decodeURI)
